import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import "assets/css/nucleo-svg.css";
import "assets/css/nucleo-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-design-system.scss?v1.0.0";

import Home from "./views/home.js";
import AboutUs from "./pages/AboutUs.js";
import Solutions from "./pages/Solutions.js";
import AccordionTerms from "./pages/TermsAndConditions.js";
import AccordionPrivacy from "./pages/PrivacyPolicy.js";
import Faqs from "./pages/Faqs.js";
import HtxMixingServiceMain from "./pages/HtxMixingServiceMain.js";
import SwrccuConference from "./pages/SwrccuConference.js";
import JobHunterMalware from "./pages/JobHunterMalware.js";
import UkCbdc from "./pages/UkCbdc.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
      <Routes>
        <Route path="/" exact element={<Home />} />
        <Route path="/about-us" exact element={<AboutUs />} />
        <Route path="/solutions" exact element={<Solutions />} />
        <Route path="/terms-and-conditions" exact element={<AccordionTerms />} />
        <Route path="/privacy-policy" exact element={<AccordionPrivacy />} />
        <Route path="/faqs" exact element={<Faqs />} />
        <Route path="/htx-mixing-service" exact element={<HtxMixingServiceMain />} />
        <Route path="/swrccu-leaders-conference" exact element={<SwrccuConference />} />
        <Route path="/job-hunter-malware" exact element={<JobHunterMalware />} />
        <Route path="/the-future-of-cbdc" exact element={<UkCbdc />} />
        <Route path="/" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
);
